module.exports = __webpack_public_path__ + "img/dzgsl.014d7b6c.png";